var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart-container"},[_c('Pie',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }